import { useState } from 'react';
import { useAppDispatch } from '../../../../app/store/configureStore';
import { deleteTableAsync } from '../store/tableSlice';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { AxiosError } from 'axios';

export const useTableActions = (restaurantId: string) => {
  const [loading, setLoading] = useState(false);
  const [target, setTarget] = useState<string | null>(null);
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const handleDelete = async (tableId: string) => {
    try {
      setLoading(true);
      setTarget(tableId);
      await dispatch(deleteTableAsync({ restaurantId, tableId })).unwrap();
      toast.success(t('table.delete.success'));
    } catch (error: unknown) {
      if (error instanceof AxiosError) {
        toast.error(error.response?.data?.title || t('common.error'));
      } else {
        toast.error(t('common.error'));
      }
    } finally {
      setLoading(false);
      setTarget(null);
    }
  };

  return { loading, target, handleDelete };
};
